module.exports = __webpack_public_path__ + "static/media/default_image.b0bc4104.svg";